// Gems Mine — frontend GameModule. Dark-launch: games.is_locked=1, so only
// dev-PIN holders reach this page until the owner opens it.
import type { GameModule } from '../types';
import Page from './Page';

const gemsMine: GameModule = {
  id: 'gems_mine',
  displayName: 'Gems Mine',
  tag: 'Casino',
  theme: {
    gradient: 'from-amber-700 to-emerald-900',
    emoji: '💎',
    logo: '/games/gems_mine/Logo.png',
  },
  orientation: 'portrait',
  adminIcon: 'diamond',
  adminTheme: {
    headerFrom: 'from-amber-900', headerTo: 'to-emerald-800',
    ring: 'ring-amber-400', accent: 'bg-amber-600', accentHover: 'hover:bg-amber-500',
    dot: 'bg-amber-400', softBg: 'bg-amber-900/30', rangeAccent: 'accent-amber-500',
    badgeClasses: 'bg-amber-600/20 text-amber-300 border-amber-600/30',
  },
  Page,
};

export default gemsMine;
